enum AmountChoice {
  Deposit = 'deposit',
  Remaining = 'remaining',
  Partial = 'partial',
}

export default AmountChoice
